import { render, staticRenderFns } from "./Bmlr.vue?vue&type=template&id=63f92398"
import script from "./Bmlr.vue?vue&type=script&lang=js"
export * from "./Bmlr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports